<template>
    <div class="ndex_Bxo">
        <!-- left-导航 -->
        <div class="L_navigation">
            <!-- 用户登录 -->
            <div class="go_login" @click="logincilck">
                <div class="log-img">
                    <img v-show="this.$store.state.LoginStatus==''" src="../assets/yonghutouxiang.png" alt="">
                    <img v-show="this.$store.state.LoginStatus!==''" style="width: 100%; height: 100%; object-fit: cover;" :src="this.$store.state.LoginStatus.image" alt="">
                </div>
                
                <div class="r-text">
                    <div class="wenzi">{{this.$store.state.LoginStatus!==''?this.$store.state.LoginStatus.username:$t('Navigation.logon')}}</div>
                    <div class="iconfont icon-youjiantou iconTu"></div>
                </div>
            </div>
            <!-- 导航 -->
            <div class="DaoHang_chin">
                <router-link to="/home" active-class="li-do-active" class="li-do">
                    <span class="iconfont icon-shouye zititubiao"></span>
                    {{$t('Navigation.homePage')}}
                </router-link>
                <router-link to="/search" active-class="li-do-active" class="li-do">
                    <span class="iconfont icon-shujutansuo zititubiao"></span>
                    {{$t('Navigation.explore')}}
                </router-link>
                <router-link to="/member" active-class="li-do-active" class="li-do">
                    <img class="zititubiao" style="width: 18px; margin-right: 10px;" src="../assets/huiyuan (2).png" alt="">
                    {{$t('Navigation.vip')}}
                </router-link>
                <router-link to="/setup" active-class="li-do-active" class="li-do">
                    <span class="iconfont icon-shezhi zititubiao"></span>
                    {{$t('Navigation.setUp')}}
                </router-link>
                <div class="li-do" @click="SQ()">
                    <img v-show="this.$store.state.ashen == 'true'" class="iconfont" src="../assets/shequhei.png" alt="">
                    <img v-show="this.$store.state.ashen == 'false'" class="iconfont" src="../assets/shequbai.png" alt="">
                    皮皮社区（敬请期待）
                </div>
                <router-link class="li-do-two" to="/popular" active-class="li-do-active" style="margin-top: 15px;">
                    <span>{{$t('Navigation.Popular')}}</span> 
                    <span class="iconfont icon-youjiantou"></span>
                </router-link>
                <router-link class="li-do-two" to="/prevalent" active-class="li-do-active">
                    <span>{{$t('Navigation.liuxing')}}</span> 
                    <span class="iconfont icon-youjiantou"></span>
                </router-link>
                <router-link class="li-do-two" to="/classics" active-class="li-do-active">
                    <span>{{$t('Navigation.jingdian')}}</span> 
                    <span class="iconfont icon-youjiantou"></span>
                </router-link>
                <router-link class="li-do-two" to="/collect" active-class="li-do-active">
                    <span>{{$t('Navigation.shoucang')}}</span> 
                    <span class="iconfont icon-youjiantou"></span>
                </router-link>

                <div @click="$router.push('/');$router.go(0);" class="log_dibu">
                    <img v-show="this.$store.state.ashen == 'true'" src="../assets/bai.png" alt="">
                    <img v-show="this.$store.state.ashen == 'false'" src="../assets/hei.png" alt="">
                </div>
            </div>
        </div>
        <!-- 右侧展示区 -->
        <div class="R_Content" :style="$store.state.BottomPlayer==true?'height: 89vh;':'height: 100vh;'">
            <!-- top 上部固定导航 -->
            <div class="Top_nav">
                <!-- 退后 -->
                <div style="display: flex; align-items: center;">
                    <div class="iconfont icon-youjiantou tuiHui" @click="HuiTuiJian"></div>
                    <div class="iconfont icon-youjiantou tuiHui" style="transform: rotate(360deg);" @click="QianjinJian"></div>
                </div>
                
                <!-- 右边 三个功能 -->
                <div class="Top-R-mftl">
                    <div class="sec-fo" @click="search()">
                        <span class="iconfont icon-sousuo sousuoimg"></span>
                        {{ $t('TOPnav.sousuo') }}
                    </div>
                    <div @click="huibai()" class="theme-zhuti">
                        <span v-if="this.$store.state.ashen=='true'" class="iconfont icon-taiyang"></span>
                        <span v-else="this.$store.state.ashen=='false'" class="iconfont icon-yueliang"></span>
                    </div>
                   
                </div>
            </div>
            <!-- 组件的展示区域 -->
            <div class="shiKou">
                <router-view></router-view>
            </div>
            
        </div>
        <!-- 底部播放器 -->
        <div class="bofang_zujian" :style="$store.state.BottomPlayer==true?'bottom: 0px;':'bottom: -102px;'">
            <div class="zhankai" @click="Zhankai_play()">
                <img :style="$store.state.BottomPlayer==true?'transform: rotate(0deg);':'transform: rotate(180deg);'"src="../assets/zhankai2.png" alt="">
            </div>
            <B-bf></B-bf>
        </div>
        
    </div>
</template>
<script>
    import Bofang from '@/components/palys/bofang.vue'
    export default {
        name:'Operate',
        components:{
            'B-bf':Bofang
        },
        data(){
            return {
            }
        },
        mounted(){
            console.log(this.$store.state.LoginStatus);
        },
        methods:{
            //灰白
            huibai(){
                if(this.$store.state.ashen=='false'){
                    this.$store.state.ashen = 'true';
                    this.$message({
                        message: '已设置主题为亮色',
                        type: 'success',
                        duration:'1000'
                    });
                    localStorage.setItem('theme','true');
                    
                }else{
                    this.$store.state.ashen = 'false';
                    this.$message({
                        message: '已设置主题为暗色',
                        type: 'success',
                        duration:'1000'
                    });
                    localStorage.setItem('theme','false');
                }
            },
            //跳转到社区
            SQ(){
                this.$store.commit('changeSqHone',true);
                this.$router.push('/shequ');
            },
            //登录
            logincilck(){
                if(this.$store.state.LoginStatus!==''){
                    this.$router.push('/geren');
                }else{
                    this.$router.push('/login');
                }
            },
            //跳转到搜索
            search(){
                this.$router.push(
                    {path: '/sousuo'}
                );
            },
            //回退按钮
            HuiTuiJian(){
                this.$router.back();
            },
            QianjinJian(){
                this.$router.go(1);
            },
            Zhankai_play(){
                if(this.$store.state.BottomPlayer==true){
                    this.$store.state.BottomPlayer=false;
                }else{
                    this.$store.state.BottomPlayer=true;
                }
                
            }
        }
    }
</script>

<style scoped lang="scss">
.bofang_zujian{
    width: 100%;
   height: 102px;
   position: absolute;
   bottom:0px;
   transition: 0.3s;
   .zhankai{
    position: absolute;
    top: -30px;
    right: 45px;
    animation: fudong 0.7s infinite alternate;
    img{
        width: 26px;
        cursor: pointer;
        transform: rotate(180deg);
       
    }
   }
   @keyframes fudong {
        from {
            top: -35px;
        }
        to {
            top: -30px;
        }
    }
}

// 视口
    .shiKou{
        overflow: hidden;
        overflow-y: auto;
        padding-top: 60px;
    }

/* 定义滚动条样式 */
.shiKou::-webkit-scrollbar {
		width: 7px;
		height: 7px;
		background: var(--them-background);
        border-radius: 50px;
}
/*定义滚动条轨道*/
.shiKou::-webkit-scrollbar-track {
		box-shadow: inset 0 0 0px var(--them-L-nav-background);
		border-radius: 10px;
		background: rgba(230, 230, 230, 0.7);
}
/*定义滑块*/
.shiKou::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 0px rgba(118, 118, 118, 0.5);
		background-color: rgba(63, 63, 63, 0.5);
}

    .ndex_Bxo{
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        background: var(--them-background);
        position: relative;
        transition: 0.3s;
    }
    /* 左边导航 */
    .L_navigation{
        width:13%;
        height: 100%;
        background:var(--them-L-nav-background);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    /* 登录 */
    .go_login{
        width: 83%;
        height: 40px;
        /* background-color: aquamarine; */
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .log-img{
        width: 37px;
        height: 37px;
        border-radius: 40px;
        background: var(--them-logImg-background);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .log-img>img{
        width: 17px;
        height: 17px;
    }
    .r-text{
        width: 73%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    .r-text>.wenzi{
        font-size: 16px;
        font-weight: 600;
        font-family: YuanTi;
        color: var(--them-L-nav-color);
    }
    .iconTu{
        font-size: 12px;
        font-weight:100;
        color: var(--them-L-nav-color);
    }
    .r-text:hover .wenzi {
        color: rgb(75, 162, 255);
    }
    .r-text:hover .iconTu {
        color: rgb(75, 162, 255);
    }
    /* 导航 */
    .DaoHang_chin{
        width: 100%;
        height: 75%;
        border-radius: 5px;
        margin-top: 23px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }
    .log_dibu{
        width: 130px;
        position: absolute;
        bottom: 0px;
        img{
            width: 100%;
        }
    }
    /* 导航的子内容 */
    .li-do{
        width: 86%;
        border-radius: 5px;
        display: flex;
        align-items: center;
        height: 35px;
        transition: 0.3s;
        cursor: pointer;
        font-size: 15px;
        // font-weight: bold;
        font-family: YuanTi;
        color: var(--them-L-nav-color);
        margin-bottom: 5px;
        img{
            width: 15px;
            height: 15px;
            margin-left: 10px;
            margin-right: 14px;
        }
    }
    .li-do:hover{
        transition: 0.3s;
        background:var(--them-L-nav-hover-background);
    }
    .li-do>.zititubiao{
        font-weight: bold;
        font-size: 15px;
        margin-left: 10px;
        margin-right: 15px;
    }
    /* 导航 第二部分 */
    .li-do-two{
        width: 86%;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 35px;
        transition: 0.3s;
        cursor: pointer;
        font-size: 15px;
        // font-weight: 600;
        font-family: YuanTi;
        color: var(--them-L-nav-color);
        margin-bottom: 7px;
    }
    .li-do-two:hover{
        transition: 0.3s;
        background:var(--them-L-nav-hover-background);
    }
    .li-do-two>span:nth-child(1){
        margin-left: 12px;
    }
    .li-do-two>span:nth-child(2){
        font-size: 10px;
        margin-right: 5px;
        font-weight: 300;
        /* color: #929292; */
    }
     /* 点击导航被激活的样式 */
    .li-do-active{
        background-color: rgb(17, 108, 255);
        color: #fff;
    }
    /* 顶掉原来的浮动改变颜色 */
    .li-do-active:hover{
        background-color: rgb(17, 108, 255);
    }

    /* 右边的内容 */
    .R_Content{
        width:87%;
        height: 89vh;
        // height: 100vh;
        /* background-color: #5a5a5a; */
        display: flex;
        flex-direction: column;
        position: relative;
    }
    /* 顶部透明导航 */
    .Top_nav{
        width: 100%;
        height: 60px;
        background:var(--them-T-nav-background);
        backdrop-filter:blur(8px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        z-index: 5;
    }
    /* 退回 */
    .tuiHui{
        width: 32px;
        height: 32px;
        background:var(--them-T-nav-tuiHui-background);
        color: var(--them-T-nav-tuiHui-color);
        border-radius: 50px;
        font-size: 12px;
        line-height: 32px;
        text-align: center;
        transform: rotate(180deg);
        cursor: pointer;
        margin-left: 18px;
    }
    /* 顶部透明 右边 三个功能样式 */
    .Top-R-mftl{
        width: 315px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-right: 17px;
    }
    .sec-fo{
        width: 235px;
        height: 35px;
        border-radius: 30px;
        background:var(--them-T-nav-tuiHui-background);
        backdrop-filter:blur(8px);
        display: flex;
        align-items: center;
        font-size: 12.5px;
        font-family: YuanTi;
        color:var(--them-T-nav-tuiHui-color);
        cursor: pointer;
    }
    .sec-fo>.sousuoimg{
        width: 20px;
        height: 20px;
        border-radius: 50px;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
        color: var( --them-color)
    }
    .theme-zhuti{
        width: 32px;
        height: 32px;
        border-radius: 50px;
        background:var(--them-T-nav-tuiHui-background);
        backdrop-filter:blur(8px);
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        font-family: YuanTi;
        cursor: pointer;
        color:var(--them-color);
    }
</style>